import { useCallback, useEffect, useMemo, useState } from 'react';

export const useAdminAdditionalInfo = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshToken, setRefreshToken] = useState(0);

  const fetchList = useCallback(async (signal) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/admin/api/process-info', { signal });
      const data = await response.json();
      if (!response.ok || data?.error) {
        throw new Error(data?.error || 'No se pudo obtener la información adicional.');
      }
      if (!signal?.aborted) {
        setItems(data.items || []);
      }
    } catch (err) {
      if (!signal?.aborted) {
        setError(err?.message || 'Error al cargar la información adicional.');
      }
    } finally {
      if (!signal?.aborted) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchList(controller.signal);
    return () => controller.abort();
  }, [fetchList, refreshToken]);

  const refresh = useCallback(() => {
    setRefreshToken((value) => value + 1);
  }, []);

  const saveInfo = useCallback(async ({ processId, htmlContent }) => {
    const response = await fetch(`/admin/api/process-info/${processId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ html_content: htmlContent })
    });
    const data = await response.json();
    if (!response.ok || data?.error) {
      throw new Error(data?.error || 'No se pudo guardar la información.');
    }
    return data?.item || null;
  }, []);

  return useMemo(() => ({
    items,
    loading,
    error,
    refresh,
    saveInfo
  }), [items, loading, error, refresh, saveInfo]);
};
